import * as React from "react";
import { Switch } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import ExternalFeeds from "./ExternalFeeds";
import ExternalFeed, {ExternalFeedProps} from "./ExternalFeed";
import ExternalFeedTest from "./ExternalFeedTest";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import routeLinks from "../../../../routeLinks";
import { RedirectFeedBasedOnType } from "./RedirectFeedBasedOnType";
import pageIds from "pageIds";
import { withPage } from "components/Page/Page";

const ExternalFeedTestPage = withPage({ page: pageIds.library.feed.test })(ExternalFeedTest);
const ExternalFeedPage = withPage({ page: pageIds.library.feed.root })(ExternalFeed);
const CreateExternalFeedPage = withPage({ page: pageIds.library.feedCreate})(ExternalFeed);
const ListExternalFeedPage = withPage({ page: pageIds.library.feeds })(ExternalFeeds);

export class ExternalFeedRoutes extends React.Component<RouteComponentProps<void>, any> {
    render() {
        const libraryRouteLinks = routeLinks.library;
        return (
            <Switch>
                <ReloadableRoute path={libraryRouteLinks.feedCreate} render={(routeProps) => <CreateExternalFeedPage create {...routeProps}/>}/>
                <ReloadableRoute path={libraryRouteLinks.feed(":feedId").redirect} component={RedirectFeedBasedOnType} />
                <ReloadableRoute path={libraryRouteLinks.feed(":feedId").test} component={ExternalFeedTestPage} />
                <ReloadableRoute path={libraryRouteLinks.feed(":feedId").root} component={ExternalFeedPage} />
                <ReloadableRoute component={ListExternalFeedPage} />
            </Switch>
        );
    }
}

export default ExternalFeedRoutes;